import { fetchOfficialTechLogsForBookings } from '../officialTechLog';
import {
  getResolvedPostFlightStatus,
  isBookingStatusLockedForDeletion,
} from './activeFlightSelection';
import { getBookingStartDate } from './bookingUtils';

export async function evaluateBookingDeletion(booking, now = new Date()) {
  if (!booking?.id) {
    return { allowed: false, reason: 'missing-booking' };
  }

  if (isBookingStatusLockedForDeletion(booking)) {
    return { allowed: false, reason: 'locked' };
  }

  const postFlightStatus = getResolvedPostFlightStatus(booking);
  const start = getBookingStartDate(booking);

  if (
    postFlightStatus !== 'did_not_fly' &&
    start &&
    now >= start
  ) {
    return { allowed: false, reason: 'booking_started' };
  }

  const { data, error } = await fetchOfficialTechLogsForBookings([booking.id]);

  // Fail safe: an unreadable tech log lookup must not allow deletion.
  if (error || (data || []).length > 0) {
    return { allowed: false, reason: 'locked' };
  }

  return { allowed: true, reason: '' };
}

export async function performBookingDeletion({
  booking,
  userId,
  supabase,
  confirmDeletion,
  now = new Date(),
}) {
  if (!booking?.id) {
    return { ok: false, reason: 'missing-booking' };
  }

  if (String(booking.user_id) !== String(userId || '')) {
    return { ok: false, reason: 'not-owner' };
  }

  const deletionCheck = await evaluateBookingDeletion(booking, now);

  if (!deletionCheck.allowed) {
    return { ok: false, reason: deletionCheck.reason };
  }

  if (
    typeof confirmDeletion === 'function' &&
    !confirmDeletion()
  ) {
    return { ok: false, reason: 'cancelled' };
  }

  const { error } = await supabase
    .from('bookings')
    .delete()
    .eq('id', booking.id)
    .eq('user_id', userId);

  if (error) {
    return { ok: false, reason: 'delete-failed', error };
  }

  return { ok: true, reason: '' };
}
